<template>
  <div class="PostItem-actions" v-if="this.$route.name !== 'content-library'">
    <div class="PostItem-buttons">
      <div class="font-secondary">{{ $t("posts.card.actionsOnThisAd") }}</div>
      <el-button-group v-if="etat != 'V' && etat != 'S'">
        <el-button v-if="typeObjet >= 3000 && typeObjet < 4000 && etat != 'M'"
                   @click="gererLots(id)"
                   size="mini"
                   plain
        >
          <span @click="eventAnalytics('gerer_lots_prom')">{{ $t("posts.card.manageLots") }}</span>
        </el-button>
        <el-button
            :to="{ name: 'post-view', params: { post: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
        </el-button>
        <el-button
            v-if="saisit_en_ligne && ((typeObjet < 3000 || typeObjet >= 4000) || possedeContactManager == false) && (!isSubUser || (isSubUser && etat !== 'M'))"
            @click="goToEdit(id)"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('edit_fiche')">{{ $t("posts.card.edit") }}</span>
        </el-button>
        <el-button
            v-if="(etat !== 'M' && etat != 'B' && !isPromoteur && !isBailleurSocial)"
            :to="{ name: 'manage-posts', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</span>
        </el-button>
        <el-button
            v-if="(etat !== 'M' && etat != 'B' && (isBailleurSocial && (typeObjet < 3000 || typeObjet >= 4000)))"
            :to="{ name: 'manage-posts', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</span>
        </el-button>
        <el-button
            v-if="(etat !== 'M' && etat != 'B' && isPromoteur && annonceParente != null)"
            :to="{ name: 'manage-posts', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</span>
        </el-button>
        <el-button
            v-if="(etat !== 'M' && typeOffre != 'L' && sitimmoUser.soldProductsOption === true && !isPromoteur && !isCmiste)"
            :to="{ name: 'edit-bien-vendu', params: { id: id } , query: {valueEtat: etat}}"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('bien-vendu')" v-if="etat == 'V'">{{ $t("posts.card.managePosts") }}</span>
          <span @click="eventAnalytics('bien-vendu')" v-else>{{$t('posts.list.bienVendu')}}</span>
        </el-button>

        <el-button :to="{name :'portals-selection-post', params: { post : id }}"
                   v-if="etat != 'M' && etat != 'B' && !sitimmoUser.soldProductsOption === true"
                   size="mini"
                   plain>
          <span @click="eventAnalytics('diffuser')">{{ $t("posts.card.diffuse") }}</span>
        </el-button>
        <el-button size="mini" plain v-if="saisit_en_ligne && etat === 'M' && $route.name !== 'content-library'" @click="$emit('open-use-model-modal', { id: id })">{{ $t("posts.card.useThisModel") }}</el-button>
        <el-button size="mini" plain v-if="etat === 'M'" @click="$emit('open-delete-modal', { id: id })"> {{ $t("posts.card.delete") }}</el-button>
        <el-dropdown @command="handleCommand" placement="top" v-if="etat !== 'M'">
          <el-button
              size="mini"
              icon="more-alt"
              type="info"
              icon-align="right"
              @click.prevent.native
              v-if="saisit_en_ligne
                                                        || (saisit_en_ligne && typeObjet >= 3000 && typeObjet < 4000 && possedeContactManager == true && (!isSubUser || (isSubUser && etat !== 'M')))
                                                        || sitimmoUser.garantiePublication && etat != 'M'
                                                        || saisit_en_ligne && (!isSubUser || (isSubUser && etat !== 'M'))"
          ></el-button>
          <el-dropdown-menu
              slot="dropdown"
              :append-to-body="false"
              :style="{
                            width: '200px',
                            transition: 'opacity 0.3s ease'
                          }"
              :popper-options="{
                            preventOverflowOrder: []
                          }"
          >
            <el-dropdown-item v-if="saisit_en_ligne && etat != 'M'"
                              :command="{name: 'duplicate', id: id}">
              {{ $t("posts.card.duplicate") }}
            </el-dropdown-item>
            <el-dropdown-item
                v-if="saisit_en_ligne && typeObjet >= 3000 && typeObjet < 4000 && (!isSubUser || (isSubUser && etat !== 'M'))"
                :command="{name: 'edit', id, sourceCode}">
              {{ $t("posts.card.edit") }}
            </el-dropdown-item>

            <el-dropdown-item v-if="!donnees.date_debut_diffusion && etat !== 'M' && etat !== 'A'" :command="{name: 'diffuseLater', id, diffuseLaterDate: donnees.date_debut_diffusion}">
              {{$t('posts.list.diffuseLater.planDiffusion')}}
            </el-dropdown-item>
            <el-dropdown-item  v-if="donnees.date_debut_diffusion && donnees.date_debut_diffusion.valeur && etat !== 'M' && etat !== 'A'" :command="{name: 'diffuseLater', id, diffuseLaterDate: donnees.date_debut_diffusion}">
              {{$t('posts.list.diffuseLater.reportDiffusion')}}
            </el-dropdown-item>

            <el-dropdown-item
                v-if="sitimmoUser.garantiePublication && etat != 'M'"
                :command="{name: 'attendanceReport', id: id}">
              {{ $t("posts.card.presenceReport") }}
            </el-dropdown-item>
            <el-dropdown-item
                v-if="saisit_en_ligne && (!isSubUser || (isSubUser && etat !== 'M'))"
                :command="{name: 'delete', id: id}">
              {{ $t("posts.card.delete") }}
            </el-dropdown-item>
            <el-dropdown-item
                v-if="$route.name != 'content-library' && etat != 'M'"
                :command="{name: 'private-note', id: id}">
              <div @click="eventAnalytics('acces_note_privee')">{{ $t("posts.card.privateNote") }}</div>
            </el-dropdown-item>
            <router-link :to="{ name: 'manage-posts', params: { id: id } }" v-if="filter.annonceParente == null && (isPromoteur || isBailleurSocial) && etat !== 'M'  && etat !== 'B'" style="text-decoration: none;">
              <el-dropdown-item>
                <div @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</div>
              </el-dropdown-item>
            </router-link>
            <router-link :to="{ name: 'manage-posts', params: { id: id } }" v-if="annonceParente == null && (isBailleurSocial) && etat !== 'M'  && etat !== 'B' && typeObjet >= 3000 && typeObjet < 4000" style="text-decoration: none;">
              <el-dropdown-item>
                <div @click="eventAnalytics('gerer_posts')">{{ $t("posts.card.managePosts") }}</div>
              </el-dropdown-item>
            </router-link>
            <router-link :to="{ name :'portals-selection-post', params: { post : id } }" v-if="((etat == 'A') && (sitimmoUser.soldProductsOption === true))" style="text-decoration: none;">
              <el-dropdown-item>
                <div @click="eventAnalytics('diffuser')">{{ $t("posts.card.diffuse") }}</div>
              </el-dropdown-item>
            </router-link>
          </el-dropdown-menu>
        </el-dropdown>
      </el-button-group>
      <el-button-group v-else-if="etat == 'V'">
        <el-button
            :to="{ name: 'post-view', params: { post: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
        </el-button>
        <el-button
            :to="{ name: 'edit-bien-vendu', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('bien-vendu')">{{ $t("posts.card.managePosts") }}</span>
        </el-button>
        <el-button :to="{name :'portals-selection-post', params: { post : id }}"
                   size="mini"
                   plain>
          <span @click="eventAnalytics('diffuser')">{{ $t("posts.card.diffuse") }}</span>
        </el-button>
        <el-button
            size="mini"
            plain
        >
          <span @click="$emit('archiver-bien-vendu-modale', { id: id, published: published })">Archiver</span>
        </el-button>
      </el-button-group>
      <el-button-group v-else-if="etat =='S'">
        <el-button
            :to="{ name: 'post-view', params: { post: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
        </el-button>
        <el-button
            :to="{ name: 'edit-bien-vendu', params: { id: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('bien-vendu')" v-if="etat == 'V'">{{ $t("posts.card.managePosts")}}</span>
          <span @click="eventAnalytics('bien-vendu')" v-else>{{$t('posts.list.bienVendu')}}</span>
        </el-button>
      </el-button-group>
    </div>

    <div class="PostItem-contacts" v-if="donnees.date_debut_diffusion && donnees.date_debut_diffusion.valeur">
      <em class="el-icon-date" style="font-size: 2em;"></em>

      <div class="PostItem-contacts-label text-center">
        {{$t('posts.list.diffuseLater.diffusedAt')}} <br>
        {{donnees.date_debut_diffusion.valeur}}
      </div>
    </div>

    <div class="PostItem-contacts" v-if="(possedeContactManager === true || etat != 'S') || etat != 'V'">
      <router-link
          :to="{ name: 'contacts-posts-detail', params: { post: reference}}"
          class="lienContactsListeAnnonces">
        <div class="PostItem-contacts-value text-center">
          {{nbContactsMailtracking}}
        </div>
        <div class="PostItem-contacts-label text-center">
          {{
            $t("posts.card.contacts")
          }}
        </div>
      </router-link>
    </div>
  </div>
  <div class="PostItem-actions" v-else>
    <div class="PostItem-buttons">
      <div class="font-secondary">{{ $t("posts.card.actionsOnThisAd") }}</div>
      <el-button-group>
        <el-button v-if="typeObjet >= 3000 && typeObjet < 4000"
                   @click="setAnnonceParente(id)"
                   size="mini"
                   plain
        >
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.manageLots") }}</span>
        </el-button>
        <el-button
            :to="{ name: 'post-view', params: { post: id } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('fiche_produit')">{{ $t("posts.card.details") }}</span>
        </el-button>
        <el-button
            v-if="saisit_en_ligne && ((typeObjet < 3000 || typeObjet >= 4000) || possedeContactManager == false) && (!isSubUser || (isSubUser && etat !== 'M'))"
            :to="{ name: 'model-edit', params: { id: id }, query: { saisie: sourceCode } }"
            size="mini"
            plain
        >
          <span @click="eventAnalytics('edit_fiche')">{{ $t("posts.card.edit") }}</span>
        </el-button>
        <el-button :to="{name :'portals-selection-post', params: { post : id }}"
                   v-if="etat != 'M' && etat != 'B'"
                   size="mini"
                   plain>
          <span @click="eventAnalytics('diffuser')">{{ $t("posts.card.diffuse") }}</span>
        </el-button>
        <el-dropdown @command="handleCommand" placement="top">
          <el-button
              size="mini"
              icon="more-alt"
              type="info"
              icon-align="right"
              @click.prevent.native
              v-if="saisit_en_ligne
                      || (saisit_en_ligne && typeObjet >= 3000 && typeObjet < 4000 && possedeContactManager == true && (!isSubUser || (isSubUser && etat !== 'M')))
                      || sitimmoUser.garantiePublication && etat != 'M'
                      || saisit_en_ligne && (!isSubUser || (isSubUser && etat !== 'M'))"
          ></el-button>
          <el-dropdown-menu
              slot="dropdown"
              :append-to-body="false"
              :style="{
                            width: '245px',
                            transition: 'opacity 0.3s ease'
                          }"
              :popper-options="{
                            preventOverflowOrder: []
                          }"
          >
            <el-dropdown-item v-if="saisit_en_ligne && etat != 'M'"
                              :command="{name: 'duplicate', id: id}">
              {{ $t("posts.card.duplicate") }}
            </el-dropdown-item>
            <el-dropdown-item
                v-if="saisit_en_ligne && typeObjet >= 3000 && typeObjet < 4000 && possedeContactManager == true && (!isSubUser || (isSubUser && etat !== 'M'))"
                :command="{name: 'edit', id, sourceCode}">
              {{ $t("posts.card.edit") }}
            </el-dropdown-item>

            <el-dropdown-item v-if="!donnees.date_debut_diffusion && etat !== 'M' && etat !== 'A'" :command="{name: 'diffuseLater', id, diffuseLaterDate: donnees.date_debut_diffusion}">
              {{$t('posts.list.diffuseLater.planDiffusion')}}
            </el-dropdown-item>
            <el-dropdown-item  v-if="donnees.date_debut_diffusion && donnees.date_debut_diffusion.valeur && etat !== 'M' && etat !== 'A'" :command="{name: 'diffuseLater', id, diffuseLaterDate: donnees.date_debut_diffusion}">
              {{$t('posts.list.diffuseLater.reportDiffusion')}}
            </el-dropdown-item>

            <el-dropdown-item
                v-if="sitimmoUser.garantiePublication && etat != 'M'"
                :command="{name: 'attendanceReport', id: id}">
              {{ $t("posts.card.presenceReport") }}
            </el-dropdown-item>
            <el-dropdown-item
                v-if="saisit_en_ligne && (!isSubUser || (isSubUser && etat !== 'M'))"
                :command="{name: 'delete', id: id}">
              {{ $t("posts.card.delete") }}
            </el-dropdown-item>
            <!--<el-dropdown-item>Enrichir</el-dropdown-item>-->
          </el-dropdown-menu>
        </el-dropdown>
      </el-button-group>
    </div>

    <div class="PostItem-contacts" v-if="donnees.date_debut_diffusion && donnees.date_debut_diffusion.valeur">
      <em class="el-icon-date" style="font-size: 2em;"></em>

      <div class="PostItem-contacts-label text-center">
        {{$t('posts.list.diffuseLater.diffusedAt')}} <br>
        {{donnees.date_debut_diffusion.valeur}}
      </div>
    </div>

    <div class="PostItem-contacts" v-if="possedeContactManager === true">
      <router-link
          :to="{ name: 'contacts-posts-detail', params: { post: reference}}"
          class="lienContactsListeAnnonces">
        <div class="PostItem-contacts-value text-center">
          {{nbContactsMailtracking}}
        </div>
        <div class="PostItem-contacts-label text-center">
          {{
            $t("posts.card.contacts")
          }}
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex'

export default {
  name: 'CardFooter',
  props: ['id', 'etat', 'published', 'typeObjet', 'typeOffre', 'sourceCode', 'donnees', 'annonceParente', 'nbContactsMailtracking', 'reference'],
  computed: {
    ...mapState('posts', ['filter', 'results']),
    ...mapGetters(['hasMultiAccounts', 'isMainAccount', 'isSubAdmin', 'isSubUser', 'getOfferTypes', 'getPickerOptionsShortcuts']),
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    },
    possedeContactManager () {
      return this.sitimmoUser.possede_contact_manager
    },
    saisit_en_ligne () {
      return (this.sitimmoUser.saisit_annonces_en_ligne === true || this.sitimmoUser.saisit_en_ligne_et_flux === true)
    },
    isPromoteur () {
      return this.sitimmoUser.metier === 'PROMOTEUR'
    },
    isCmiste () {
      return this.sitimmoUser.metier === 'CMI'
    },
    isBailleurSocial () {
      return this.sitimmoUser.metier === 'BAILLEUR_SOCIAL'
    }
  },
  methods: {
    ...mapMutations('dialogsPostsListImmo', [
        'SET_MODAL_DELETE',
        'SET_POST_TO_DELETE',
        'SET_MODAL_DUPLICATE'
    ]),
    eventAnalytics (category) {
      this.$ga.event('annonce', 'clic', category, this.sitimmoUser.id)
    },
    goToEdit (id) {
      if(this.typeObjet >= 3000 && this.typeObjet < 4000 && !this.annonceParente) {
        this.filter.creationProgramme = true
      }  
      this.$router.push({
        name: 'post-edit',
        params: { id: id },
        query: { saisie: this.sourceCode }
      })
    },
    handleCommand (command) {
      if (command.name === 'delete') {
        this.SET_MODAL_DELETE(true)
        this.SET_POST_TO_DELETE(command.id)
      } else if (command.name === 'useModel') {
        this.$emit('open-use-model-modal', { id: command.id })
      } else if (command.name === 'duplicate') {
        this.$emit('open-duplicate-modal', { id: command.id })
      } else if (command.name === 'edit') {
        if(this.typeObjet >= 3000 && this.typeObjet < 4000 && !this.annonceParente) {
          this.filter.creationProgramme = true
        }  
        this.$router.push({
          name: 'post-edit',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      } else if (command.name === 'attendanceReport') {
        this.eventAnalytics('rapport_presence')
        this.$router.push({ name: 'attendance-report-post', params: { post: command.id } })
      } else if (command.name === 'diffuseLater') {
        this.eventAnalytics('programmer_diffusion')
        this.$emit('diffuse-later', { id: command.id, diffuseLaterDate: command.diffuseLaterDate })
      } else if (command.name === 'private-note') {
        this.eventAnalytics('acces_note_privee')
        this.$router.push({
          name: 'private-note',
          params: { id: command.id },
          query: { saisie: command.sourceCode }
        })
      }
    },
    gererLots (id) {
      // entre programmes et lots, on reset des filtres
      this.filter.search = null
      this.filter.objectTypes = null
      this.filter.priceGt = null
      this.filter.priceLt = null
      this.filter.surfaceGt = null
      this.filter.surfaceLt = null
      this.filter.annoncesActivees = true
      this.$emit('annonce-parente', id)
    }
  }
}
</script>
<style scoped>
.el-button-group {
    display: inline!important;
}
.PostItem-actions .PostItem-buttons{
    min-width: max-content;
}
.el-dropdown {
    vertical-align: top;
}
.el-dropdown + .el-dropdown {
    margin-left: 15px;
}
</style>
